'use client'
import React from 'react'

type Props = {}

// eslint-disable-next-line no-unused-vars
const UnderConstruction = (props: Props) => {
    return (
        <div className="fixed w-full sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-1/4 bottom-4 sm:bottom-1/3 left-1/2 transform -translate-x-1/2 sm:left-auto sm:right-2 sm:transform-none z-10 px-4 sm:px-0">
            <div className="bg-gray-200 flex flex-col sm:flex-row sm:items-start sm:justify-between dark:bg-slate-900 shadow-lg sm:shadow sm:rounded-2xl rounded-xl overflow-hidden opacity-90 sm:opacity-70 border-2 border-white dark:border-slate-300 h-full">
                <div className="flex flex-row w-full">
                    <div className="flex flex-col flex-none w-14 items-center justify-center p-4 bg-yellow-600">
                        <span className="material-symbols-outlined text-yellow-200 text-4xl mb-2">construction</span>                        
                    </div>
                    <div className="flex-1 flex flex-col justify-center p-4">
                        <h2 className="mb-2 text-base font-semibold text-gray-900 dark:text-gray-300 uppercase">Under Construction</h2>
                        <p className="text-sm text-gray-800 dark:text-gray-300">
                            We are working hard to improve this site. Please check back soon!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnderConstruction